import React, {PropsWithChildren} from "react";
import { observer } from "mobx-react";
import { OrbitComponent } from "../../../base-components/orbit-component/orbit-component";
import { action, observable, runInAction, makeObservable } from "mobx";
import { BurnoutAnimationWrapper } from "../../../burnout/burnout-animation/burnout-animation-wrapper.component";
import { Button } from "../../../../basic-ui-components/button/base/button.component";
import {Label} from "../../boxes/label";

enum BurnoutAnimationScenario {
    GotOMG,
    NotYetOMG
}

@observer
export class BurnoutAnimationShowcase extends OrbitComponent {
    constructor(props: PropsWithChildren) {
        super(props);

        makeObservable(this);
    }


    @observable.ref
    private _paused = false;
    @observable.ref
    private _renderAnimation = false;
    @observable.ref
    private _scenario = BurnoutAnimationScenario.GotOMG;

    private checkOmg = () => {
        return (this._scenario === BurnoutAnimationScenario.GotOMG);
    }

    @action.bound
    private togglePauseAnimation = () => {
        this._paused = !this._paused;
    };

    @action.bound
    private toggleRenderAnimation = () => {
        this._renderAnimation = !this._renderAnimation;
    }


    render() {
        return <div>
            <div>Dismiss type:
                {[
                    [BurnoutAnimationScenario.GotOMG, "Got OMG"],
                    [BurnoutAnimationScenario.NotYetOMG, "Not Yet OMG"]
                ].map((scenario) =>
                    <div key={scenario[0]}>
                        <input
                            type="radio" name="scenario" id={"scenario_" + scenario[0]} value={scenario[0]}
                            checked={this._scenario === scenario[0]}
                            onChange={(ev) => {
                                runInAction(() => {
                                    this._scenario = parseInt(ev.target.value) as BurnoutAnimationScenario
                                })
                            }}
                        />
                        <Label style={{fontSize: "1.6rem"}} htmlFor={"scenario_" + scenario[0]}>{scenario[1]}</Label>
                    </div>
                )}
            </div>
            <div style={{marginBlockEnd: "1rem"}}>
                <Button preset="primary" onClick={() => {
                    this.toggleRenderAnimation();
                }}>{this._renderAnimation ? "Remove" : "Render"} burnout</Button>
                {this._renderAnimation ? <Button preset="info" onClick={() => {
                    this.togglePauseAnimation();
                }}>{this._paused ? "Play" : "Pause"} burnout animation</Button>: null}
            </div>
            <div>Known issues: On iOS the fade animation and floating button animation have some problems. Don't try to
                change the orientation of the device while the animation is playing
            </div>

            {this._renderAnimation ? <BurnoutAnimationWrapper
                checkOmg={this.checkOmg}
                // showOmg={this.toggleRenderAnimation}
                onSafeUnmountNotice={this.toggleRenderAnimation}
                paused={this._paused}
            /> : null}
        </div>;
    }
}
